/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-secondary[_ngcontent-%COMP%]:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-success[_ngcontent-%COMP%]{color:#fff;background-color:#3ecb90;border-color:#3ecb90}.form-rename-folder[_ngcontent-%COMP%]{margin:35px 35px 0}.form-rename-folder[_ngcontent-%COMP%]   .rename-modal-footer[_ngcontent-%COMP%]{margin-bottom:15px}"];
export { styles as styles };
